export default (state, { payload: userData }) => ({
  ...state,
  user: { ...state.user, ...userData },
})
